<!-- your-component.component.html -->
<div class="getterms-document-embed" 
     data-getterms="Ch9Zc" 
     data-getterms-document="tos" 
     [attr.data-getterms-lang]="getLanguage()"  
     data-getterms-mode="direct"></div>

